import LazyLoad, { ILazyLoadInstance } from 'vanilla-lazyload'

import 'flickity'
import 'flickity/dist/flickity.min.css'

import 'styles/theme.scss'

import '@/components/custom-elements/registerCustomElements'

import 'libs/searchspring/searchspring-init'

import { cart, Cart } from '../helpers/cart'
import { session } from '../helpers/session'

declare global {
  interface Window {
    Cart: Cart | null;
    Session: typeof session;
    lazyLoadInstance: ILazyLoadInstance;
    Shopify: {
        country: string;
        routes: {
          root: string;
      };
    };
  }
}

window.Cart = cart
window.Session = session
window.lazyLoadInstance = new LazyLoad()
window.lazyLoadInstance.update()
